import { Component, Input } from '@angular/core';
import type { ILabReq } from '@care-portals/api-interfaces';

@Component({
  selector: 'my-health-lab-req-view',
  styleUrls: ['./lab-req-view.component.less'],
  template: `
    <div class="lab-req-view">
      <ng-container [ngSwitch]="labReq?.templateId">
        <lab-req-on
          [labReq]="labReq"
          *ngSwitchCase="'trt1on'"
          title="TRT1ON"
        ></lab-req-on>
        <lab-req-on
          [labReq]="labReq"
          *ngSwitchCase="'wlon'"
          title="WLON"
        ></lab-req-on>
        <lab-req-on
          [labReq]="labReq"
          *ngSwitchCase="'lgvon'"
        ></lab-req-on>
        <app-lab-req-bc
          [data]="labReq?.data"
          [editable]="false"
          [templateVariant]="labReq?.templateVariant"
          [customerGender]="$any(labReq?.customer)?.gender"
          *ngSwitchCase="'bc'"
        ></app-lab-req-bc>
        <app-lab-req-qc
          [data]="labReq?.data"
          [editable]="false"
          [templateVariant]="labReq?.templateVariant"
          [customerGender]="$any(labReq?.customer)?.gender"
          *ngSwitchCase="'qc'"
        ></app-lab-req-qc>
        <app-lab-req-sk
          [data]="labReq?.data"
          [editable]="false"
          [templateVariant]="labReq?.templateVariant"
          [customerGender]="$any(labReq?.customer)?.gender"
          *ngSwitchCase="'sk'"
        ></app-lab-req-sk>
        <app-lab-req-ab
          [data]="labReq?.data"
          [editable]="false"
          [templateVariant]="labReq?.templateVariant"
          [customerGender]="$any(labReq?.customer)?.gender"
          *ngSwitchCase="'ab'"
        ></app-lab-req-ab>
        <app-lab-req-nf
          [data]="labReq?.data"
          [editable]="false"
          [templateVariant]="labReq?.templateVariant"
          [customerGender]="$any(labReq?.customer)?.gender"
          *ngSwitchCase="'nf'"
        ></app-lab-req-nf>
      </ng-container>
    </div>
  `
})
export class LabReqViewComponent {
  @Input() labReq: ILabReq;

  constructor() {}
}
